export const environment = {
  production: false,
  apiUrl:'https://bainescredit-support-mcp-client-dev-56229428262.us-central1.run.app/',
  prefix:'dev_',
  firebaseApp: { 
    projectId: "bainescredit-automation", 
    appId: "1:56229428262:web:4bcddf18a3ce243cbabae7", 
    storageBucket: "bainescredit-automation.firebasestorage.app", 
    apiKey: "AIzaSyB-L9mVJT19m1XokbRaMRs558GX8Rc8ns8", 
    authDomain: "bainescredit-automation.firebaseapp.com", 
    messagingSenderId: "56229428262", 
    measurementId: "G-HD0QS7P7TE" 
  },
  endpoints:{
  // firebaseApiKey: 'Dev_KEY_HERE'
  SEND_MESSAGE:'send-email',
  DAILY_CONVERSATIONS:'analytics/daily',
  CONVERSATIONS:'analytics/conversations',
  CONVERSATION_ANALYTICS: 'analytics/conversation-activity',
  SEND_MSG:'user-response/send-message',
  SEND_TEMPLATE:'user-response/send-template',
  UPDATE_STATE:'user-response/update-state',
  CREATE_USER:'config/users',
  BUSINESS_INTELLIGENECE:'business-intelligence'
  

},
collections:{
  BILLING:'billing',
  USERS:'users',
  CONVERSATIONS:'conversation_state'

}
}